import { ICommand } from 'core-ts-types';

export function MyFavoritesRoutes($stateProvider: ng.ui.IStateProvider) {
  $stateProvider.state('my.favorites', {
    url: 'favorites/',
    templateUrl: 'capability-ng-favorites/src/views/my_favorites_category/my_favorites_category.html',
    controller: 'MyFavoritesCategoryController',
    controllerAs: '$ctrl',
    data: {
      viewTitle: 'My Favorites',
      hasMainMenu: true,
      ignoredInHistory: false
    }
  });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/routes.ts